import { useMemo } from "react"

import { Navigate, useRoutes } from "react-router-dom"

import { RiskZonesDesktopRoutes } from "../../../modules/riskZones/routers/RiskZonesRoutes"
import { SpeedingsDesktopRoutes } from "../../../modules/speedings/routers/SpeedingsRoutes"
import { MODULE_RISK_ZONES, MODULE_SPEEDINGS } from "../../constants/modules"

export const SafetyContentRouter = () => {

    const safetyRoutes = useMemo(() => ([
        {
            path: `/${MODULE_RISK_ZONES}/*`,
            element: <RiskZonesDesktopRoutes />,
        },
        {
            path: `/${MODULE_SPEEDINGS}/*`,
            element: <SpeedingsDesktopRoutes />,
        },
        {
            path: "*",
            element: <Navigate replace to={`${MODULE_RISK_ZONES}`} />,
        },
    ]), [])

    return useRoutes(safetyRoutes)
}